//
// Copyright (c) 2011-2019 by Curalate, Inc.
//

import { IListManagerItem } from 'unison';

export enum CATALOG_INGESTION_TYPES {
  MAGENTO = 'Magento',
  SHOPIFY = 'Shopify',
  OTHER = 'Other',
}

export enum CATALOG_SELECTION_MODAL_ACTIONS {
  CHANGE_CATALOG_TYPE = 'CATALOG_SELECTION_MODAL_ACTIONS/CHANGE_CATALOG_TYPE',
  OPEN_MODAL = 'CATALOG_SELECTION_MODAL_ACTIONS/OPEN_MODAL',
  CLOSE_MODAL = 'CATALOG_SELECTION_MODAL_ACTIONS/CLOSE_MODAL',
  SET_SELECTED_ECOMMERCE_TYPE = 'CATALOG_SELECTION_MODAL_ACTIONS/SET_SELECTED_ECOMMERCE_TYPE',
  RECEIVE_SELECTED_ECOMMERCE_TYPE = 'CATALOG_SELECTION_MODAL_ACTIONS/RECEIVE_SELECTED_ECOMMERCE_TYPE'
}

export const CATALOG_INGESTION_TYPES_LABLES = {
  [CATALOG_INGESTION_TYPES.MAGENTO]: CATALOG_INGESTION_TYPES.MAGENTO,
  [CATALOG_INGESTION_TYPES.SHOPIFY]: CATALOG_INGESTION_TYPES.SHOPIFY,
  [CATALOG_INGESTION_TYPES.OTHER]: CATALOG_INGESTION_TYPES.OTHER,
};

export const getCatalogTypes = (): Array<IListManagerItem<string>> => {
  return Object.keys(CATALOG_INGESTION_TYPES_LABLES).map((key) =>
    ({
      label: CATALOG_INGESTION_TYPES_LABLES[key],
      value: CATALOG_INGESTION_TYPES_LABLES[key]
    })
  );
};
